exports = module.exports = require("../../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "fieldset._2sRA7BIsxaOiIhgJFDaHUs {\n\tborder: 1px solid #d9d9d9;\n\tborder-radius: 3px;\n\tpadding: .35em .625em .75em;\n\tmargin-bottom: .75em;\n}\n\nfieldset.B2Pk00kbSjoJH4PnCv84Z > * {\n\tdisplay: none;\n}\n\nfieldset._38CmwvfCDdXKT_2jj71v0j > * {\n\tdisplay: block;\n}\n\nfieldset._2sRA7BIsxaOiIhgJFDaHUs legend a{\n\tcolor: black;\n}\n\nfieldset._2sRA7BIsxaOiIhgJFDaHUs legend {\n\tdisplay: block !important;\n\twidth: auto;\n\tpadding: 0 0.5em;\n\tmargin: 0;\n\tfont-size: inherit;\n\tborder: 0;\n\tcursor: pointer;\n}\n", ""]);

// exports
exports.locals = {
	"portalCollapsibleLanguageField": "_2sRA7BIsxaOiIhgJFDaHUs",
	"collapsed": "B2Pk00kbSjoJH4PnCv84Z",
	"open": "_38CmwvfCDdXKT_2jj71v0j"
};